export default "__VITE_ASSET__yfO3qEgT__"